import { getAnnualReturnUsingRiskScore, PayOffDebtGoal } from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getProgressUsingTargetAmount } from '../helpers';
import { BaseGoalConfig } from './types';

export const PAY_OFF_DEBT: BaseGoalConfig<PayOffDebtGoal> = {
    iconName: 'GoalDebt',
    color: colorsByGoalType['PAY_OFF_DEBT'].primary,
    defaultName: 'Pay down debt',
    getDescription: () => 'Free your wallet and your mind.',
    group: 'TRACK',
    blogLink: null,
    getAnnualReturn: getAnnualReturnUsingRiskScore,
    getProgress: (config) => getProgressUsingTargetAmount(config),
};
